module.exports = __webpack_public_path__ + "z/social.2ec36ec3.png";